import { Typography, Divider, Box } from '@mui/material';

type SectionHeaderProps = {
  examName: string;
};

const SectionHeader = ({ examName }: SectionHeaderProps) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant='h4' component='h2'>
        {examName}
      </Typography>

      <Typography variant='body1' color='text.secondary' sx={{ mt: 2 }}>
        List of sessions
      </Typography>

      <Divider sx={{ mt: 2, borderBottomWidth: 1 }} />
    </Box>
  );
};

export default SectionHeader;
